export default function set(values) {
  return values instanceof Set ? values : new Set(values);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-array/src/set.js
// module id = 4909
// module chunks = 0